module.exports = __webpack_public_path__ + "images/emoji/finnadie.a7d61e84ff03ebe867ca.png";